import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/src/components/blocks/AboutServiceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/src/components/blocks/ParallaxHero.tsx");
